import { c as _c } from "react/compiler-runtime";
import { Form, Formik } from 'formik';
import { useContext } from 'react';
import { APIDestination } from '../../../../../../../../typings/Destination.interface';
import field_formats from '../../../../../utils/field-formatters';
import { cleanseFormErrorObject } from '../../../../../utils/form';
import Button from '../../../../common/base/Button';
import { StyledCard, StyledCardSection } from '../../../../common/base/Card';
import Icon, { IconName } from '../../../../common/base/Icon';
import Link from '../../../../common/base/Link';
import Text from '../../../../common/base/Text';
import Tooltip from '../../../../common/base/Tooltip';
import DropdownMenu, { DropdownMenuOption } from '../../../../common/DropdownMenu';
import SelectInput, { StyledField } from '../../../../common/Form/Fields/SelectInput';
import SwitchInput from '../../../../common/Form/Fields/SwitchInput';
import TextAreaInput from '../../../../common/Form/Fields/TextAreaInput';
import TextInput from '../../../../common/Form/Fields/TextInput';
import { Div } from '../../../../common/helpers/StyledUtils';
import { useToasts } from '../../../../common/Toast';
import { GlobalContext } from '../../../../contexts/GlobalContext';
import { DashboardContext } from '../../DashboardContext';
import destination_configuration_form_props from '../Forms/destination_configuration';
import resource_details_form_props from '../Forms/resource_details';
import { ResourcesContext } from '../ResourcesContext';
import useOnDelete from './hooks/useOnDeleteToggle';
import useOnDisableToggle from './hooks/useOnDisableToggle';
import { StatusBadge, tooltip_status } from './StatusBadge';
import { PreviewTypeContainer } from './PreviewTypeContainer';
import Divider from '../../../../common/base/Divider';
type DestinationPreviewField = 'name' | 'type' | 'url' | 'max_delivery_rate' | 'status' | 'open' | 'disable' | 'delete';
interface Props {
  destination: APIDestination;
  fields?: DestinationPreviewField[];
  mutate?: () => any;
}
const DestinationPreview = t0 => {
  const $ = _c(68);
  const {
    destination,
    fields,
    mutate
  } = t0;
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  const {
    mutateResourceType
  } = useContext(ResourcesContext);
  const {
    team,
    destination_types
  } = useContext(DashboardContext);
  const {
    addToast
  } = useToasts();
  const onDisable = useOnDisableToggle("destinations", mutate);
  const onDelete = useOnDelete("destinations");
  let t1;
  if ($[0] !== fields) {
    t1 = fields ? fields.includes("status") : true;
    $[0] = fields;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const show_status = t1;
  let t2;
  if ($[2] !== fields) {
    t2 = fields ? fields.includes("type") : true;
    $[2] = fields;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const show_type = t2;
  let t3;
  if ($[4] !== fields) {
    t3 = fields ? fields.includes("name") : true;
    $[4] = fields;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const show_name = t3;
  let t4;
  if ($[6] !== fields) {
    t4 = fields ? fields.includes("url") : true;
    $[6] = fields;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const show_url = t4;
  let t5;
  if ($[8] !== fields) {
    t5 = fields ? fields.includes("max_delivery_rate") : true;
    $[8] = fields;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const show_max_delivery_rate = t5;
  let t6;
  if ($[10] !== fields) {
    t6 = fields ? fields.includes("open") : true;
    $[10] = fields;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const show_open = t6;
  let t7;
  if ($[12] !== fields) {
    t7 = fields ? fields.includes("disable") : true;
    $[12] = fields;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const show_disable = t7;
  let t8;
  if ($[14] !== fields) {
    t8 = fields ? fields.includes("delete") : true;
    $[14] = fields;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  const show_delete = t8;
  let dropdown_options;
  if ($[16] !== destination || $[17] !== onDelete || $[18] !== onDisable || $[19] !== show_delete || $[20] !== show_disable) {
    dropdown_options = [] as DropdownMenuOption[];
    if (show_disable) {
      let t9;
      if ($[22] !== destination || $[23] !== onDisable) {
        t9 = destination.disabled_at ? {
          label: "Enable destination",
          icon: "enable",
          onClick: () => onDisable(destination, false)
        } : {
          label: "Disable destination",
          icon: "disable",
          onClick: () => onDisable(destination, true)
        };
        $[22] = destination;
        $[23] = onDisable;
        $[24] = t9;
      } else {
        t9 = $[24];
      }
      dropdown_options.push(t9);
    }
    if (show_delete) {
      let t9;
      if ($[25] !== destination || $[26] !== onDelete) {
        t9 = {
          label: "Delete destination",
          icon: "delete",
          danger: true,
          onClick: () => onDelete(destination)
        };
        $[25] = destination;
        $[26] = onDelete;
        $[27] = t9;
      } else {
        t9 = $[27];
      }
      dropdown_options.push(t9);
    }
    $[16] = destination;
    $[17] = onDelete;
    $[18] = onDisable;
    $[19] = show_delete;
    $[20] = show_disable;
    $[21] = dropdown_options;
  } else {
    dropdown_options = $[21];
  }
  let t9;
  if ($[28] !== destination || $[29] !== show_status) {
    t9 = show_status && <Div p={4} flex={{
      gap: 2,
      align: "center"
    }}><StatusBadge resource={destination} /><Tooltip tooltip={tooltip_status("destination", destination)} side="bottom"><Icon muted={true} icon="info" /></Tooltip></Div>;
    $[28] = destination;
    $[29] = show_status;
    $[30] = t9;
  } else {
    t9 = $[30];
  }
  let t10;
  if ($[31] !== HookdeckAPI.destinations || $[32] !== addToast || $[33] !== destination.id || $[34] !== mutate || $[35] !== mutateResourceType) {
    t10 = (values, t11) => {
      const {
        resetForm
      } = t11;
      const post_process_values = destination_configuration_form_props.postprocessValues(values) as any;
      if (post_process_values.config) {
        post_process_values.config.auth_type = undefined;
        post_process_values.config.auth = undefined;
      }
      return HookdeckAPI.destinations.update(destination.id, {
        name: values.name,
        ...post_process_values
      }).then(updated_destination => {
        mutateResourceType?.("destinations", updated_destination);
        resetForm({
          values: {
            name: updated_destination.name,
            ...destination_configuration_form_props.getInitialValues(updated_destination)
          },
          touched: {}
        });
        mutate?.();
        addToast("success", "Destination updated");
      }).catch(e => {
        addToast("error", `An error occurred while saving the destination${e.response?.data[0] ? `: ${e.response.data[0]}` : ""}`);
      });
    };
    $[31] = HookdeckAPI.destinations;
    $[32] = addToast;
    $[33] = destination.id;
    $[34] = mutate;
    $[35] = mutateResourceType;
    $[36] = t10;
  } else {
    t10 = $[36];
  }
  let t11;
  if ($[37] !== HookdeckAPI.destinations || $[38] !== destination.name) {
    t11 = async values_0 => {
      const errors = {
        ...(await resource_details_form_props.validate(values_0, name => name === destination.name ? Promise.resolve(false) : HookdeckAPI.destinations.nameIsUsed(name))),
        ...(await destination_configuration_form_props.validate(values_0))
      };
      return cleanseFormErrorObject(errors);
    };
    $[37] = HookdeckAPI.destinations;
    $[38] = destination.name;
    $[39] = t11;
  } else {
    t11 = $[39];
  }
  const t12 = destination.name;
  let t13;
  if ($[40] !== destination) {
    t13 = destination_configuration_form_props.getInitialValues(destination);
    $[40] = destination;
    $[41] = t13;
  } else {
    t13 = $[41];
  }
  let t14;
  if ($[42] !== destination.name || $[43] !== t13) {
    t14 = {
      name: t12,
      ...t13
    };
    $[42] = destination.name;
    $[43] = t13;
    $[44] = t14;
  } else {
    t14 = $[44];
  }
  let t15;
  if ($[45] !== destination.config || $[46] !== destination.id || $[47] !== destination_types || $[48] !== dropdown_options || $[49] !== fields || $[50] !== show_delete || $[51] !== show_disable || $[52] !== show_max_delivery_rate || $[53] !== show_name || $[54] !== show_open || $[55] !== show_status || $[56] !== show_type || $[57] !== show_url || $[58] !== team) {
    t15 = t16 => {
      const {
        dirty,
        resetForm: resetForm_0,
        isSubmitting,
        isValid,
        values: values_1
      } = t16;
      const show_search_tooltip = (values_1.config.path || values_1.config.url)?.includes("?");
      const {
        rate_limit,
        rate_limit_period
      } = values_1.config;
      let show_rate_limit_warning = false;
      if (rate_limit_period !== "concurrent") {
        let rate_limit_per_second = Number(rate_limit);
        if (rate_limit_period === "minute") {
          rate_limit_per_second = Number(rate_limit) / 60;
        } else {
          if (rate_limit_period === "hour") {
            rate_limit_per_second = Number(rate_limit) / 3600;
          }
        }
        if (rate_limit_per_second > team.max_events_per_second) {
          show_rate_limit_warning = true;
        }
      }
      const destination_type = destination_types?.[values_1.type];
      return <Form><StyledCardSection p={{
          x: 4,
          b: 4,
          t: show_status || !show_type ? 0 : 4
        }}>{show_type && <StyledField large={true} block={true}><Text muted={true} semi={true} size="xs" m={{
              b: 1
            }}>Destination type</Text><PreviewTypeContainer icon={destination_type?.icon as IconName} label={destination_type?.label ?? ""} /></StyledField>}{show_url && values_1.type === "CLI" && <TextInput m={{
            t: 4
          }} name="config.path" label="Destination Path" placeholder="/webhooks" help="Path to forward the request to on your localhost." required={true} />}{show_name && <Div m={{
            t: 4
          }}><TextAreaInput mono={true} name="name" label="Destination Name" required={true} m={0} auto_resize={true} format={field_formats.slugify} maxlength={155} /></Div>}{show_url && values_1.type === "HTTP" && <Text muted={true} semi={true} size="xs" m={{
            t: 4,
            b: 1
          }}>Destination URL</Text>}{["HTTP", "MOCK_API"].includes(values_1.type) && <>{show_url && values_1.type && values_1.type === "HTTP" && <><TextAreaInput name="config.url" mono={true} auto_resize={true} placeholder="https://example.com/api/webhooks" m={{
                b: 2
              }} />{show_search_tooltip && <Text flex={{
                align: "center",
                gap: 1
              }} muted={true} size="s" m={{
                t: 2
              }}><Icon icon="info" /><span>URL query params will replace event query params.</span></Text>}</>}{show_max_delivery_rate && <>{fields && fields?.length === 1 ? <Div m={{
                t: 4
              }} /> : <Text semi={true} muted={true} size="xs" m={{
                t: 4,
                b: 2
              }} text_wrap={false} flex={{
                align: "center",
                gap: 2
              }}>Delivery Policy<Divider /></Text>}<StyledCard dashed={!values_1.enable_rate_limit} p={3}><Div flex={{
                  justify: "flex-start",
                  align: "center",
                  gap: 3
                }}><SwitchInput name="enable_rate_limit" /><Text>Max delivery rate</Text></Div>{values_1.enable_rate_limit && <Div m={{
                  t: 3
                }} flex={{
                  gap: 2
                }}><TextInput w={50} name="config.rate_limit" placeholder="50" type="number" default_value={team?.max_events_per_second ? team?.max_events_per_second.toString() : "5"} min={1} m={0} /><SelectInput w={50} m={0} block={true} portal={true} name="config.rate_limit_period" options={[{
                    value: "second",
                    label: "per second"
                  }, {
                    value: "minute",
                    label: "per minute"
                  }, {
                    value: "hour",
                    label: "per hour"
                  }, {
                    value: "concurrent",
                    label: "concurrent"
                  }]} required={true} /></Div>}{show_rate_limit_warning && <Div m={{
                  t: 3
                }} flex={{
                  align: "flex-start",
                  gap: 2
                }}><Icon icon="warning" muted={true} m={{
                    t: 0.5
                  }} /><Text muted={true} size="s">Your max delivery rate value is higher than your project throughput limit of {team?.max_events_per_second} events per second which determines the effective delivery rate.<Link icon="link" to="/settings/project/quotas?view=throughput">Modify throughput</Link></Text></Div>}</StyledCard>{"delivery_policy" in destination.config && !!destination.config.delivery_policy?.groups && <StyledCard m={{
                t: 4
              }} overflow_hidden={true}><StyledCardSection muted={true} p={{
                  x: 4,
                  y: 3
                }} flex={{
                  align: "flex-start",
                  gap: 2
                }}><Icon icon="info" muted={true} m={{
                    t: 0.5
                  }} /><Text muted={true}>Delivery groups enabled at{" "}{destination.config.delivery_policy.groups.rate}/{destination.config.delivery_policy.groups.rate_period} with{" "}{Object.keys(destination.config.delivery_policy.groups.overrides || {}).length}{" "}overrides.{" "}<Link icon="link" to={`/destinations/${destination.id}/settings`}>Manage delivery groups</Link></Text></StyledCardSection></StyledCard>}</>}</>}</StyledCardSection><StyledCardSection p={{
          x: 4,
          y: 3
        }} flex={{
          justify: "flex-end",
          gap: 3
        }}>{dirty || !show_open && !show_disable && !show_delete ? <>{dirty && <Button onClick={() => resetForm_0()} outline={true}>Cancel</Button>}<Button submit={true} primary={true} icon="save" disabled={isSubmitting || !isValid || !dirty}>{isSubmitting ? <Icon icon="loading" /> : "Save"}</Button></> : <>{show_open && <Button to={`/destinations/${destination.id}`} outline={true} icon="open">Open</Button>}{(show_disable || show_delete) && <DropdownMenu.Permission outline={true} portal={true} icon="horizontal_more" placement="bottom-end" options={dropdown_options} />}</>}</StyledCardSection></Form>;
    };
    $[45] = destination.config;
    $[46] = destination.id;
    $[47] = destination_types;
    $[48] = dropdown_options;
    $[49] = fields;
    $[50] = show_delete;
    $[51] = show_disable;
    $[52] = show_max_delivery_rate;
    $[53] = show_name;
    $[54] = show_open;
    $[55] = show_status;
    $[56] = show_type;
    $[57] = show_url;
    $[58] = team;
    $[59] = t15;
  } else {
    t15 = $[59];
  }
  let t16;
  if ($[60] !== t10 || $[61] !== t11 || $[62] !== t14 || $[63] !== t15) {
    t16 = <Formik onSubmit={t10} validate={t11} initialValues={t14}>{t15}</Formik>;
    $[60] = t10;
    $[61] = t11;
    $[62] = t14;
    $[63] = t15;
    $[64] = t16;
  } else {
    t16 = $[64];
  }
  let t17;
  if ($[65] !== t16 || $[66] !== t9) {
    t17 = <>{t9}{t16}</>;
    $[65] = t16;
    $[66] = t9;
    $[67] = t17;
  } else {
    t17 = $[67];
  }
  return t17;
};
export default DestinationPreview;